export default {
  autoCompleteInput: "new-password",
};
